import { motion } from 'framer-motion'
import React from 'react'
import { Link } from 'react-router-dom'
function Card({ data }) {

    const tourCard = {
        hidden: {
            opacity: 0,
            x: "-3rem",
            scale:0
        },
        show: {
            opacity: 1,
            x: 0,
            scale:1  
        }
    }
    return (
        <div className="col l4 m6 s12">
            <motion.div
                variants={tourCard}
                initial="hidden"
                animate="show"
                transition={{ duration: 0.4, type: "spring" }}
                className="card">
                <div className="card-image">
                    <img src={data.recipe.image} alt={data.recipe.image} />
                    <div className="receipeInfo">
                        <span className="card-title">{data.recipe["cautions"]}</span>
                        <Link to={data.recipe["cautions"] } className="btn-floating halfway-fab waves-effect waves-light blue darken-2">
                            <i className="material-icons">add</i>
                        </Link>
                    </div>
                </div>
            </motion.div>
        </div>
    )
}

export default Card
